// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\GeoActivity\ApiGeoActivity.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { GeoActivityTrigger } from 'server/enums/GeoActivityTrigger';

// GeoActivityData is the class that GeoActivity serializes to/from
export interface GeoActivityData {
    Id : number;
	
    Domain : DomainData | null;
    DomainId : number;
    Event : EventData | null;
    EventId : number;
    LocationId : number | null;
    PortCall : PortCallData | null;
    PortCallId : number | null;
    PortLocation : LocationData | null;
    Vessel : VesselData | null;
    VesselId : number;
	
    Message : string | null;
    TriggerType : GeoActivityTrigger;
}

// GeoActivityOptions is the class which may be passed to the GeoActivity constructor to define optional initial data values
export interface GeoActivityOptions {
    Id : number;
	
    Domain? : DomainOptions | null;
    DomainId? : number;
    Event? : EventOptions | null;
    EventId? : number;
    LocationId? : number | null;
    PortCall? : PortCallOptions | null;
    PortCallId? : number | null;
    PortLocation? : LocationOptions | null;
    Vessel? : VesselOptions | null;
    VesselId? : number;
	
    Message? : string | null;
    TriggerType? : GeoActivityTrigger;
}

export class GeoActivity {
    public Id : DataSignal<number>;
	
    public Domain : DataSignal<Domain | null>;
    public DomainId : DataSignal<number>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public LocationId : DataSignal<number | null>;
    public PortCall : DataSignal<PortCall | null>;
    public PortCallId : DataSignal<number | null>;
    public PortLocation : DataSignal<Location | null>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number>;
	
    public Message : DataSignal<string | null>;
    public TriggerType : DataSignal<GeoActivityTrigger>;

    constructor();
    constructor(data : GeoActivityOptions);
    constructor(data: GeoActivityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Domain = S.value<Domain | null>(null);
        this.DomainId = jsonableObservable(S.value<number>(data && data.DomainId !== undefined ? data.DomainId : 0));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.LocationId = jsonableObservable(S.value<number | null>(data && data.LocationId !== undefined ? data.LocationId : null));
        this.PortCall = S.value<PortCall | null>(null);
        this.PortCallId = jsonableObservable(S.value<number | null>(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.PortLocation = S.value<Location | null>(null);
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.Message = jsonableObservable(S.value<string | null>(data && data.Message !== undefined ? data.Message : null));
        this.TriggerType = jsonableObservable(S.value<GeoActivityTrigger>(data && data.TriggerType !== undefined ? data.TriggerType : 0));
    }

    static key(obj : GeoActivity) {
        return obj.Id();
    }
    
    static dataKey(obj : GeoActivityOptions) {
        return obj.Id;
    }

    static update(obj : GeoActivity, data : GeoActivityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.DomainId !== undefined) obj.DomainId(data.DomainId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.LocationId !== undefined) obj.LocationId(data.LocationId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.Message !== undefined) obj.Message(data.Message);
            if (data.TriggerType !== undefined) obj.TriggerType(data.TriggerType);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/GeoActivity.ts